import { Redeem } from "@mui/icons-material";
import { isDoubleDpc } from "../utils/config";
import useCategory from "../utils/useCategory";
import Product from "./Product";
import { Alert } from "@mui/material";
import moment from "moment";

const supported = {
    'dentaire': 2,
    'kine': 1,
    'sante-mentale': 2,
    'pharma': 2,
    'medecine': 2,
    'infirmiere': 1
}

/**
 * 
 * À afficher entre le 14/10 et le 31/12 2024
 */
export default function NewDpcPi({ product }){

    const category = useCategory()

    const showADFMessage = category?.id === 'dentaire' &&
        moment().valueOf() > moment('2024-11-27T00:00:00.000Z').valueOf() &&
        moment().valueOf() < moment('2024-12-01T00:00:00.000Z').valueOf();

    return product &&

        <Product product={product}>

            <div className="apply-option-title">
                <span>DPC</span>
            </div>

            <div className="apply-option-row">
                <span><b>Programme Intégré</b></span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>100% pris en charge</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Sans avance de frais</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>
                    Indemnité allant jusqu'à 
                </span>
                <span className="apply-badge-grey" style={{backgroundColor: category?.color, color: 'white'}}>
                    {product.price}€
                </span>
            </div>

            {showADFMessage ? <>
                <div className="apply-option-divider"></div>

                <div className="apply-option-row">
                    <Alert severity="info" icon={<Redeem />}>
                        <b>Offre ADF</b> <br/>
                        Une formation offerte ou un cas clinique commenté d'une MasterClass au choix.
                    </Alert>
                </div>
            </> : <>
                <div className="apply-option-divider"></div>

                <div className="apply-option-row">
                    {isDoubleDpc ? 
                        <span>
                            Jusqu'à <b>{supported[category?.id] || 1}</b> formation(s) DPC prises en charge par an
                        </span>
                        :
                        <span>
                            Utilise vos crédits DPC 2026.
                        </span>
                    }
                </div>
            </>}

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Inscription dès 1h de crédit restant</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Session d'une durée maximale de 6 mois au cours de laquelle vous devez achever votre formation</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>L'EPP1 - FC - 3 mois de pause - L'EPP2</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Combine FC et EPP*</span>
            </div>

        </Product>
}